import { render, staticRenderFns } from "./signUpCom.vue?vue&type=template&id=53c5cd48&"
import script from "./signUpCom.vue?vue&type=script&lang=js&"
export * from "./signUpCom.vue?vue&type=script&lang=js&"
import style0 from "./signUpCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports